import styled from 'styled-components';
import { Input } from 'antd';

// NX-3941: numeric fields are text inputs (so a malformed paste stays visible
// and can be corrected). Mirrors AppInput's visual treatment (height/radius/
// border/hover) so the numeric field is a drop-in sibling.
export const StyledNumericInput = styled(Input)`
  width: 100%;
  height: 40px;
  font-size: 16px;
  font-weight: 400;
  border-radius: 8px;
  color: rgba(22, 23, 26, 1);
  border: 1px solid ${({ theme }) => theme.palette.neutral[300]};

  &:hover,
  &:focus,
  &.ant-input-affix-wrapper-focused {
    box-shadow: none !important;
    border-color: ${({ theme }) => theme.palette.secondary.main} !important;
  }

  &.ant-input-disabled,
  &.ant-input-affix-wrapper-disabled,
  &.ant-input-affix-wrapper-readonly {
    color: ${({ theme }) => theme.palette.text.primary};
    -webkit-text-fill-color: ${({ theme }) => theme.palette.text.primary};
    background-color: ${({ theme }) => theme.palette.background.default};
    border-color: ${({ theme }) => theme.palette.neutral[300]} !important;
    cursor: not-allowed;

    .ant-input {
      color: ${({ theme }) => theme.palette.text.primary};
      -webkit-text-fill-color: ${({ theme }) => theme.palette.text.primary};
      cursor: not-allowed;
    }

    &:hover,
    &:focus {
      border-color: ${({ theme }) => theme.palette.neutral[300]} !important;
      box-shadow: none !important;
    }
  }

  .ant-input-prefix {
    margin-inline-end: 8px;
    .anticon {
      font-size: 16px;
    }
  }

  /* NX-5506: with an addon (e.g. the Attachment Order "Protected Minimum" %/£
     selector) antd renders this styled root as the OUTER .ant-input-group-wrapper
     and draws its own borders on the inner input + addon. The height/border/radius
     above then also land on the wrapper, giving a double border and a height
     mismatch (wrapper 40px vs inner input 32px) — the "%/£ crammed into the field"
     look. Neutralise the wrapper and treat the inner control as the 40px field. */
  &.ant-input-group-wrapper {
    height: auto;
    border: none;
    border-radius: 0;

    .ant-input-group,
    .ant-input {
      height: 40px;
    }

    .ant-input-group-addon:first-child {
      border-radius: 8px 0 0 8px;
    }

    .ant-input:last-child {
      border-radius: 0 8px 8px 0;
    }
  }
`;
